import {
  $bestMarketPrices,
  getBestMarketPricesFx,
} from '@/modules/mixing/store/analytical-mixing.store';
import { BestPricesResponseItem } from '@/modules/mixing/ts/buyers-prices.types';
import { PageTemplate } from '@/shared/ui/templates';
import { fetchWarehousesForMixingDataFx } from '@/widgets/recipe/model';
import { Spin } from 'antd';
import { useStore } from 'effector-react';
import { useEffect, useRef } from 'react';
import { WarehouseSection } from '../../components/warehouse-section';
import styles from './index.module.sass';
import { BestPriceWarehouseItem } from '@/modules/mixing/store/analytical-mixing.store';

export const BestPricesPage = ({ tooltipData, setTooltipData }: IArgs) => {
  const data: any = useStore($bestMarketPrices);
  const tpRef = useRef(null);

  const searchParams = new URLSearchParams(location.search);
  const tons = searchParams.get('tons');
  const recipesCount = searchParams.get('recipes_count');
  const mixAlgo = searchParams.get('mix_algo');

  useEffect(() => {
    fetchWarehousesForMixingDataFx({
      tons: Number(tons),
      recipesCount: Number(recipesCount),
      mixAlgo: Number(mixAlgo),
    });
  }, []);

  useEffect(() => {
    getBestMarketPricesFx(true);
    //return () => setInitialStateBestMarketPrices();
  }, []);
  return (
    <PageTemplate
      className={styles.frame}
      header="Стоимость ваших складов по лучшей рыночной цене без использования миксования, с осушением и увлажнением
        "
    >
      <div className={styles.root}>
        {data && Array.isArray(data) ? (
          data.length > 0 ? (
            data?.map((item: BestPriceWarehouseItem, i: number) => (
              <WarehouseSection
                expandedByDefault={i === 0}
                data={item}
                key={i}
                tooltipData={tooltipData}
                setTooltipData={setTooltipData}
              />
            ))
          ) : (
            <span className={styles.placeholder}>данные отсутствуют</span>
          )
        ) : data?.error ? (
          <span className={styles.error}>
            Ошибка при загрузке данных, попробуйте позже
          </span>
        ) : (
          <div className={styles.loader}>
            <Spin size="large" />
          </div>
        )}

        <div
          className={styles.priceDetalisation}
          ref={tpRef}
          style={{
            display: tooltipData.display ? 'none' : 'none',
            top: tooltipData.top - 170,
            left: tooltipData.left,
          }}
        >
          <span className={styles.row}>
            <span className={styles.label}>Стоимость пшеницы</span>
            <span className={styles.val}>{tooltipData.price_all} ₽</span>
          </span>
          <span className={styles.row}>
            <span className={styles.label}>Стоимость доставки</span>
            <span className={styles.val} style={{ color: 'rgba(64, 155, 255, 1)' }}>
              {tooltipData.delivery_price} ₽
            </span>
          </span>
          <span className={styles.row}>
            <span className={styles.label}>НЕТТО (логистика)</span>
            <span className={styles.val} style={{ color: 'rgba(0, 126, 60, 1)' }}>
              {tooltipData.net_price} ₽
            </span>
          </span>
        </div>
      </div>
    </PageTemplate>
  );
};

interface IArgs {
  tooltipData: any;
  setTooltipData: (val: any) => void;
}
